import { Typography, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import RadioButton from "../../../common/RadioButton";
import { LinkButton, SecondaryButton } from "../../../common/Buttons";
import {
  getHealthcareProxy,
  getHealthcareQuestionByCategory,
  postHealthcareProxy,
} from "../../../services/documentServices";
import { QuestionByCategoryType } from "../../../constants/constants";
import { toast } from "react-hot-toast";
import { getUserIdFromLocalStorage } from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";

const AuthoritiesAndMedical = ({ next, setButtonDisabled }) => {
  const { t } = useTranslation();
  let uID = getUserIdFromLocalStorage();
  const [medicalCareListState, setMedicalCareListState] = useState([]);

  const [authorities, setAuthorities] = useState([]);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  async function fetchData() {
    setIsLoading(true);
    try {
      const result = await getHealthcareProxy(uID);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }
  async function fetchQuestions() {
    setButtonDisabled(true);
    const result = await getHealthcareQuestionByCategory(
      QuestionByCategoryType.MEDICAL_CARE,
      uID
    );
    if (result?.success) {
      setMedicalCareListState(
        {
          title: result?.payLoad?.[0],
          data: result?.payLoad[0]?.questions?.map((item) => ({
            id: item.questionId,
            yes: item?.healthProxyAnswer?.answer
              ? item?.healthProxyAnswer?.answer === "yes"
                ? true
                : false
              : null,
            ...item,
            ...item.healthProxyAnswer,
            subQuestions: item?.subQuestions?.length
              ? item.subQuestions.map((elem) => ({
                id: elem.subQuestionId,
                yes: item?.healthProxyAnswer?.answer
                  ? item?.healthProxyAnswer?.answer === "yes"
                    ? true
                    : false
                  : null,
                ...elem,
                ...elem.healthProxyAnswer,
              }))
              : null,
          }))
        }
      );
    }
    setButtonDisabled(false);
  }

  async function fetchAuthorities() {
    setButtonDisabled(true);
    const result = await getHealthcareQuestionByCategory(
      QuestionByCategoryType.AUTHORITIES,
      uID
    );
    if (result?.success) {
      setAuthorities(
        {
          title: result?.payLoad?.[0],
          data: result?.payLoad[0]?.questions?.map((item) => ({
            id: item.questionId,
            yes: item?.healthProxyAnswer?.answer
              ? item?.healthProxyAnswer?.answer === "yes"
                ? true
                : false
              : null,
            ...item,
            ...item.healthProxyAnswer,
          }))
        }
      );
    }
    setButtonDisabled(false);
  }

  useEffect(() => {
    fetchData();
    fetchQuestions();
    fetchAuthorities();
  }, []);


  const setYes = (e) => {
    const updateList = {
      ...medicalCareListState,
      data: medicalCareListState?.data?.map((ele) => {
        if (ele.subQuestions !== null) {
          return {
            ...ele,
            subQuestions: ele?.subQuestions?.map((sub) => {
              return sub.id === e.id ? { ...sub, yes: true } : sub;
            }),
          };
        }
        return ele.id == e.id ? { ...ele, yes: true } : ele;
      })
    };
    setMedicalCareListState(updateList);
  };
  const setNo = (e) => {
    const updateList = {
      ...medicalCareListState,
      data: medicalCareListState?.data?.map((ele) => {
        if (ele.subQuestions !== null) {
          return {
            ...ele,
            subQuestions: ele.subQuestions?.map((sub) => {
              return sub.id === e.id ? { ...sub, yes: false } : sub;
            }),
          };
        }
        return ele.id == e.id ? { ...ele, yes: false } : ele;
      })
    };
    setMedicalCareListState(updateList);
  };


  const setAllTrueMedical = (currentObj) =>
    currentObj.subQuestions?.length
      ? currentObj?.subQuestions?.every((item) => item.yes)
      : currentObj.yes;


  const setAuthoritiesYes = (e) => {
    const updateList = {
      ...authorities,
      data: authorities?.data?.map((ele) => {
        return ele.id == e.id ? { ...ele, yes: true } : ele;
      })
    };
    setAuthorities(updateList);
  };
  const setAuthoritiesNo = (e) => {
    const updateList = {
      ...authorities,
      data: authorities?.data?.map((ele) => {
        return ele.id == e.id ? { ...ele, yes: false } : ele;
      })
    };
    setAuthorities(updateList);
  };

  const setAllTrue = (currentObj) => currentObj.yes == true;

  const handleSubmit = async () => {
    let array = data?.healthProxyAnswers?.filter((elem) => {
      return !Boolean(
        medicalCareListState?.data?.some(
          (item) => item?.questionId === elem?.questionId
        )
      );
    });
    const tempArray = [];
    medicalCareListState.data.forEach((item) => {
      if (item.subQuestions !== null) {
        item.subQuestions.forEach((sub) => {
          tempArray.push({
            ...sub,
            answer: sub.yes ? "yes" : sub.yes == null ? null : "no",
          });
        });
      } else {
        tempArray.push({
          ...item,
          answer: item.yes ? "yes" : item.yes == null ? null : "no",
        });
      }
    });
    setButtonDisabled(true);

    let tempoSubmit = array ? [...tempArray, ...array] : tempArray
    const payload = {
      ...data,
      healthProxyAnswers: [
        ...data.healthProxyAnswers,
        ...tempoSubmit,
        // ...residanceAndHousing?.map((item) => ({
        //   ...item,
        //   answer: item.yes ? "yes" : item.yes == null ? null : "no",
        // })),
        ...authorities?.data?.map((item) => ({
          ...item,
          answer: item.yes ? "yes" : item.yes == null ? null : "no",
        })),
      ],
      checkListTab2:
        authorities?.data.every(setAllTrue) &&
          medicalCareListState?.data.every(setAllTrueMedical)
          ? 2
          : 1,
    };
    const result = await postHealthcareProxy(payload, uID);
    if (result?.success) {
      // toast.success(
      //   t(
      //     result?.message
      //       .toLowerCase()
      //       .replaceAll(" ", "-")
      //       .replaceAll("/", "-")
      //       .replaceAll(",", "")
      //       .replaceAll("'", "")
      //   )
      // );
      next();
    }
    setButtonDisabled(false);
  };

  return (
    <form
      id="form_submit"
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
      className="summary-table documents-card-height"
    >
      {isLoading ? (
        <Box component="div" className="loader-container">
          <Circles color="#dfc8db" height={80} width={80} />
        </Box>
      ) : (
        <Box component="div" width="60%" className="medical-care-container">
          {console.log('authorities', authorities)}
          <Typography variant="p" fontWeight="bold" className="mt-5">
            {t(authorities?.title?.translationKey)}
          </Typography>
          <Box padding="0 2rem" component="div" className="section-1">
            <Box component="div" className="sub-section-1">
              <Typography variant="p" marginRight="1rem">
                {t("YES")}
              </Typography>
              <Typography variant="p"> {t("no")}</Typography>
            </Box>
            <ol>
              {authorities?.data?.length > 0 && authorities?.data?.map((elem, index) => {
                return (
                  <li>
                    <Box component="div" key={index} className="sub-section-2">
                      <Typography variant="p" margin="0 0.5rem" width="80%">
                        {elem?.translationKey ? t(elem.translationKey) : ""}
                      </Typography>
                      <RadioButton
                        value="0"
                        theme="box"
                        paddingLeft="1rem"
                        checked={elem.yes}
                        onChange={() => {
                          setAuthoritiesYes(elem);
                        }}
                      />
                      <RadioButton
                        value="1"
                        theme="box"
                        checked={!elem.yes && elem.yes != null}
                        onChange={() => {
                          setAuthoritiesNo(elem);
                        }}
                      />
                    </Box>
                  </li>
                );
              })}
            </ol>
          </Box>
          <Typography variant="p" fontWeight="bold">
            {t(medicalCareListState?.title?.translationKey)}
          </Typography>
          <Box padding="0 2rem" component="div" className="section-1">
            <Box component="div" className="sub-section-1">
              <Typography
                color="color.magentaDark2"
                variant="p"
                marginRight="1rem"
              >
                {t("YES")}
              </Typography>
              <Typography color="color.magentaDark2" variant="p">
                {t("NO")}
              </Typography>
            </Box>
            <ol>
              {medicalCareListState?.data?.length > 0 && medicalCareListState?.data?.map((elem, index) => {
                return (
                  <div key={index}>
                    <li>
                      <Box
                        component="div"
                        key={index}
                        className="sub-section-2"
                      >
                        <Typography
                          color="color.magentaDark2"
                          variant="p"
                          margin="0 0.5rem"
                          width="80%"
                        >
                          {elem?.translationKey ? t(elem.translationKey) : ""}
                        </Typography>
                        {elem.subQuestions === null && (
                          <>
                            <RadioButton
                              value="0"
                              theme="box"
                              paddingLeft="1rem"
                              checked={elem.yes}
                              onChange={() => {
                                setYes(elem);
                              }}
                            />
                            <RadioButton
                              value="1"
                              theme="box"
                              checked={!elem.yes && elem.yes != null}
                              onChange={() => {
                                setNo(elem);
                              }}
                            />
                          </>
                        )}
                      </Box>
                      {elem.subQuestions !== null && (
                        <>
                          {elem.subQuestions.map((sub, subIndex) => (
                            <Box
                              component="div"
                              key={subIndex}
                              className="sub-section-2"
                            >
                              <Typography
                                color="color.magentaDark2"
                                variant="p"
                                margin="0 0.5rem"
                                width="80%"
                              >
                                {sub?.translationKey
                                  ? t(sub.translationKey)
                                  : ""}
                              </Typography>

                              <RadioButton
                                value="0"
                                theme="box"
                                paddingLeft="1rem"
                                checked={sub.yes}
                                onChange={() => {
                                  setYes(sub);
                                }}
                              />
                              <RadioButton
                                value="1"
                                theme="box"
                                checked={!elem.yes && elem.yes != null}
                                onChange={() => {
                                  setNo(sub);
                                }}
                              />
                            </Box>
                          ))}
                        </>
                      )}
                    </li>
                  </div>
                );
              })}
            </ol>
          </Box>

        </Box>
      )}
    </form>
  );
};

export default AuthoritiesAndMedical;
